import React, {useCallback, useState} from 'react';
import {Button, Modal}                from "antd";
import {Form, Input, Alert}           from "antd";
import api                            from "../js/api.js";
import utils                          from "../js/utils.js";
import locale                         from "../localization/locale";
import form_validator                 from "../js/form_validators";
import form_utils                     from "../components/_form_utils";
import selector                       from "../js/selector.json";

const LoginForm = (props) => {
    const [loginError, setLoginError] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [form]                          = Form.useForm();

    const login = useCallback(() => {
        (async () => {
            let data = await form_utils.get_form_value(form);
            if (!data)
                return;
            setLoginError(false);
            setConfirmLoading(true);
            api("login", {data}, {return_error :true}, result => {
                setConfirmLoading(false);
                if (result && result.token) {
                    utils.setCookie("token", result.token, utils.dateTime.add(new Date(), "hour", 8), "/")
                }

                if (result.error) {
                    setLoginError(true)
                }
                else {
                    props.cbLogin(result);
                }
            })
        })()
    }, [form, props]);

    return (
        <Modal
            centered={true}
            closable={false}
            title={locale.get("login.title")}
            visible={!props.token}
            footer={null}
            onFinish={login}
            data-test={selector.login.modal}
        >
            {loginError && <Alert message={locale.get("login.message.login_error")} type="error" data-test={selector.login.alert}/>}
            <Form
                layout={"vertical"}
                name="login"
                initialValues={{ remember: false }}
                form={form}
                onFinish={login}
            >
                <Form.Item
                    label={locale.get("login.label.email")}
                    name="email"
                    title={locale.get("login.tooltip.default")}
                    autoComplete="off"
                    rules={[{
                        required: true,
                        validator: form_validator.email_validation
                    }]}
                >
                    <Input placeholder={locale.get("login.placeholder.email")} autoComplete="off" data-test={selector.login.input.email}/>
                </Form.Item>

                <Form.Item
                    label={locale.get("login.label.password")}
                    name="password"
                    autoComplete="off"
                    rules={[{
                        required: true,
                        validator: form_validator.validate_pass
                    }]}
                >
                    <Input.Password  placeholder={locale.get("login.placeholder.password")} autoComplete="off"  data-test={selector.login.input.password}/>
                </Form.Item>

                <Form.Item>
                    <Button htmlType="submit" type="primary" loading={confirmLoading} data-test={selector.login.button}>
                        {locale.get("login.button.log_in")}
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
};

LoginForm.defaultProps = {
    token: "",
    cbLogin: () => {}
};

export default LoginForm;
